const isSnapchatActive = () => {
  return Boolean(
    !window.location.origin.includes("test") &&
      !window.location.pathname.includes("oauth") &&
      !window.location.pathname.includes("payment-") &&
      (window.location.origin.includes("anythingbutboring") ||
        window.location.origin.includes("noghosting.app")) &&
      //@ts-ignore
      window.snaptr,
  )
}

export const trackSnapchatClick = () => {
  if (isSnapchatActive()) {
    //@ts-ignore
    window.snaptr("track", "ADD_CART")
  }
}

export const trackSnapchatSignup = (method: string) => {
  if (isSnapchatActive() && !sessionStorage.getItem("sc_signup_tracked")) {
    //@ts-ignore
    window.snaptr("track", "SIGN_UP", {
      sign_up_method: method,
    })
    sessionStorage.setItem("sc_signup_tracked", "1")
  }
}

export const trackSnapchatPurchaseClick = (
  price: number,
  currency: string,
  bundleName: string,
) => {
  if (
    isSnapchatActive() &&
    !sessionStorage.getItem("sc_start_checkout_tracked")
  ) {
    //@ts-ignore
    window.snaptr("track", "START_CHECKOUT", {
      price,
      currency,
      item_ids: [bundleName],
    })
    sessionStorage.setItem("sc_start_checkout_tracked", "1")
  }
}

export const trackSnapchatPurchaseSuccess = (
  price: number,
  currency: string,
  bundleName: string,
) => {
  if (isSnapchatActive() && !sessionStorage.getItem("sc_purchase_tracked")) {
    //@ts-ignore
    window.snaptr("track", "PURCHASE", {
      price,
      currency,
      item_ids: [bundleName],
    })
    sessionStorage.setItem("sc_purchase_tracked", "1")
  }
}

export function getSnapchatClickId(): string | null {
  try {
    const getQueryParam = (name: string): string | null => {
      const params = new URLSearchParams(location.search)

      const direct = params.get(name)
      if (direct) return direct

      const keys = Array.from(params.keys())
      for (let i = 0; i < keys.length; i++) {
        const key = keys[i]
        if (key.toLowerCase() === name.toLowerCase()) {
          return params.get(key)
        }
      }

      return null
    }

    const getCookie = (name: string): string | null => {
      const match = document.cookie.match(
        new RegExp(
          "(^|; )" +
            name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") +
            "=([^;]*)",
        ),
      )
      return match ? decodeURIComponent(match[2]) : null
    }

    const scCid = getQueryParam("ScCid")
    if (scCid) return scCid

    const cookieId = getCookie("_scid")
    if (cookieId) return cookieId

    const clickId = getQueryParam("sc_click_id")
    if (clickId) return clickId

    return null
  } catch {
    return null
  }
}
